// extracted by mini-css-extract-plugin
export default {"list_card":"ShoppingCart_list_card__adJwR","list_img":"ShoppingCart_list_img__coCgD","buton_cart":"ShoppingCart_buton_cart__pUmf1"};